import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'input-group\' ...attributes {{did-update this.syncValue @value}}>\n  {{!-- silent-guard-ok: the stepper follows its own field: disabled together with it --}}\n  <button\n    type=\'button\'\n    aria-label=\'Decrementa\'\n    class=\'input-group-label\'\n    disabled={{@disabled}}\n    data-test-remove-step\n    {{on \'click\' this.removeStep}}\n  >\n    <FaIcon @icon=\'minus\' />\n  </button>\n  <Input\n    @type=\'number\'\n    @value={{this._value}}\n    min={{@min}}\n    max={{@max}}\n    step={{this._step}}\n    disabled={{@disabled}}\n    autocomplete=\'off\'\n    class=\'input-group-field\' data-test-on-change {{on \'change\' this.onChange}}\n  />\n  {{!-- silent-guard-ok: the stepper follows its own field: disabled together with it --}}\n  <button\n    type=\'button\'\n    aria-label=\'Incrementa\'\n    class=\'input-group-label\'\n    disabled={{@disabled}}\n    data-test-add-step\n    {{on \'click\' this.addStep}}\n  >\n    <FaIcon @icon=\'plus\' />\n  </button>\n</div>");

var _class, _descriptor, _descriptor2;
let BbInputNumberComponent = (_class = class BbInputNumberComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "_value", _descriptor, this);
    _initializerDefineProperty(this, "_step", _descriptor2, this);
    this._step = isNaN(parseFloat(this.args.step)) ? 1 : parseFloat(this.args.step);
    this._value = this.args.value === '' || this.args.value == null || isNaN(this.args.value) ? this.args.min ?? 0 : this.args.value;
  }

  // Sincronizza quando il valore cambia esternamente (es. disabled + parent aggiorna)
  syncValue() {
    const newStep = isNaN(parseFloat(this.args.step)) ? 1 : parseFloat(this.args.step);
    const newValue = this.args.value === '' || this.args.value == null || isNaN(this.args.value) ? this.args.min ?? 0 : this.args.value;
    this._step = newStep;
    this._value = newValue;
  }
  addStep() {
    let newValue = parseFloat(this._value) + this._step;
    if (this.args.max != null && newValue > this.args.max) {
      newValue = parseFloat(this.args.max);
    }
    this._value = newValue;
    this.args.onChangeAction?.(newValue, 'add');
  }
  removeStep() {
    let newValue = parseFloat(this._value) - this._step;
    if (this.args.min != null && newValue < this.args.min) {
      newValue = parseFloat(this.args.min);
    }
    this._value = newValue;
    this.args.onChangeAction?.(newValue, 'sub');
  }

  // Chiamato quando l'utente digita direttamente nel campo numerico
  onChange(event) {
    const raw = event.target.value;
    if (raw === '' || raw == null) {
      this._value = this.args.min ?? 0;
      this.args.onChangeAction?.(this._value, 'input');
      return;
    }
    let newValue = parseFloat(raw);
    if (isNaN(newValue)) return;
    if (this.args.min != null) newValue = Math.max(this.args.min, newValue);
    if (this.args.max != null) newValue = Math.min(this.args.max, newValue);
    this._value = newValue;
    this.args.onChangeAction?.(newValue, 'input');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_value", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_step", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "syncValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "syncValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeStep", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeStep"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbInputNumberComponent);

export { BbInputNumberComponent as default };
//# sourceMappingURL=bb-input-number.js.map
